import { UUID } from './idGenerator';

const VOTE_KEY = 'satisfactionSurveyVoted';
const VOTE_EXPIRY_DAYS = 30;
const USER_ID = 'powerbiUserId';

export function setVoted(value: boolean): void {
  const data = {
    value,
    timestamp: Date.now(),
  };
  localStorage.setItem(VOTE_KEY, JSON.stringify(data));
}

export function getVoted(): boolean {
  const item = localStorage.getItem(VOTE_KEY);
  if (!item) return false;
  try {
    const { value, timestamp } = JSON.parse(item);
    if (Date.now() - timestamp > VOTE_EXPIRY_DAYS * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(VOTE_KEY);
      return false;
    }
    return !!value;
  } catch {
    localStorage.removeItem(VOTE_KEY);
    return false;
  }
}

export function getOrCreateUserId(): string {
  let userId = localStorage.getItem(USER_ID);
  if (!userId) {
    userId = UUID();
    localStorage.setItem(USER_ID, userId);
  }
  return userId;
}
